"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.SUCCESS_DURATION = exports.Label = exports.LOADER_MIN_DURATION = void 0;
var _classnames = _interopRequireDefault(require("classnames"));
var _react = _interopRequireWildcard(require("react"));
var _Icon = _interopRequireDefault(require("../Icon"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
const LOADER_MIN_DURATION = exports.LOADER_MIN_DURATION = 400; // minimium duration (ms) loader displays
const SUCCESS_DURATION = exports.SUCCESS_DURATION = 2000; // duration (ms) success tick is displayed
let Label = exports.Label = /*#__PURE__*/function (Label) {
  Label["WAITING"] = "Waiting for action to complete";
  Label["SUCCESS"] = "Action completed";
  return Label;
}({});
/**
 * This is a not an existing Vanilla component. It can be used to display submitting states for forms or other actions.
 *
 * ActionButton accepts the props from
 * [Button](?path=/docs/components-button--docs) in addition to those in the
 * props table:
 */
const ActionButton = _ref => {
  let {
    appearance,
    children,
    className,
    disabled = false,
    inline = false,
    loading = false,
    success = false,
    ...buttonProps
  } = _ref;
  const [height, setHeight] = (0, _react.useState)();
  const [width, setWidth] = (0, _react.useState)();
  const [showLoader, setShowLoader] = (0, _react.useState)(false);
  const [showSuccess, setShowSuccess] = (0, _react.useState)(false);
  const ref = (0, _react.useRef)(null);

  // Set up loader timer
  (0, _react.useEffect)(() => {
    let loaderTimeout;
    if (loading) {
      // Explicitly set button dimensions
      if (ref.current && !!ref.current.getBoundingClientRect()) {
        setHeight(ref.current.getBoundingClientRect().height);
        setWidth(ref.current.getBoundingClientRect().width);
      }
      setShowLoader(true);
    }
    if (!loading && showLoader) {
      loaderTimeout = window.setTimeout(() => {
        setShowLoader(false);
        if (success) {
          setShowSuccess(true);
        }
      }, LOADER_MIN_DURATION);
    }
    if (!loading && !showLoader) {
      setHeight(null);
      setWidth(null);
    }
    return () => window.clearTimeout(loaderTimeout);
  }, [loading, showLoader, success]);

  // Set up success timer
  (0, _react.useEffect)(() => {
    let successTimeout;
    if (showSuccess) {
      successTimeout = window.setTimeout(() => {
        setHeight(null);
        setWidth(null);
        setShowSuccess(false);
      }, SUCCESS_DURATION);
    }
    return () => window.clearTimeout(successTimeout);
  }, [showSuccess]);
  const buttonClasses = (0, _classnames.default)(className, "p-action-button", appearance ? "p-button--".concat(appearance) : "p-button", {
    "is-processing": showLoader || showSuccess,
    "is-disabled": disabled,
    "is-inline": inline
  });
  const showIcon = showLoader || showSuccess;
  const icon = showLoader && "spinner" || showSuccess && "success" || null;
  const iconLight = appearance === "positive" || appearance === "negative";

  // This component uses the base button element instead of the Button component
  // as the button requires a ref and Button would have to be updated to use
  // forwardRef which is not currently supported by components that use
  // typescript generics.
  return /*#__PURE__*/_react.default.createElement("button", _extends({
    className: buttonClasses,
    disabled: disabled,
    ref: ref,
    style: height && width ? {
      height: "".concat(height, "px"),
      width: "".concat(width, "px")
    } : undefined
  }, buttonProps), showIcon ? /*#__PURE__*/_react.default.createElement(_Icon.default, {
    "aria-label": showLoader ? Label.WAITING : Label.SUCCESS,
    className: showLoader ? "u-animation--spin" : null,
    light: iconLight,
    name: icon
  }) : children);
};
var _default = exports.default = ActionButton;